import { ofType } from "redux-observable";
import { of, from } from "rxjs";
import { catchError, switchMap, mergeMap } from "rxjs/operators";
import { deleteInvitation, getInvitedUsersForLogisticsParty } from "../../../actions/userManagementActions";
import { DELETE_INVITATION_REQUEST, DELETE_INVITATION_SUCCESS, DELETE_INVITATION_FAILURE } from "../../../actions/userManagementActions/actionTypes";
import { addNotification } from "../../../actions/ui";
import { DEFAULT_NOTIFICATION_CLOSE_TIMEOUT, NotificationTypeEnum } from "../../../actions/ui/types";
import { errorBodyForCodeMap } from "../../../constants/error";
export var deleteInvitationEpic = function(action$, state$, param) {
    var api = param.api;
    return action$.pipe(ofType(DELETE_INVITATION_REQUEST), switchMap(function(action) {
        return from(api.userManagementServices.deleteInvitation(action.payload).pipe(mergeMap(function(response) {
            var ref;
            return of(deleteInvitation.success(response.invitationStatus), getInvitedUsersForLogisticsParty.request({
                logisticsPartyId: (ref = action.payload) === null || ref === void 0 ? void 0 : ref.logisticsPartyId
            }), addNotification({
                type: NotificationTypeEnum.SUCCESS,
                action: DELETE_INVITATION_SUCCESS,
                body: "delete_invitation_notifications.success",
                timeout: DEFAULT_NOTIFICATION_CLOSE_TIMEOUT
            }));
        }), catchError(function(err) {
            var ref, ref1;
            var errBody = (err === null || err === void 0 ? void 0 : (ref = err.receivedException) === null || ref === void 0 ? void 0 : (ref1 = ref.exceptionDetails) === null || ref1 === void 0 ? void 0 : ref1.errorCode) ? errorBodyForCodeMap[err.receivedException.exceptionDetails.errorCode] || "" : "";
            return of(deleteInvitation.failure(err), addNotification({
                type: NotificationTypeEnum.ERROR,
                action: DELETE_INVITATION_FAILURE,
                body: errBody || "delete_invitation_notifications.failure",
                timeout: DEFAULT_NOTIFICATION_CLOSE_TIMEOUT
            }));
        })));
    }));
};
export default deleteInvitationEpic;

//# sourceMappingURL=index.js.map